import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { UPDATES } from '../games/updates';
import { GameLinks } from '../components/GameLinks';
import { formatDay } from '../games/fresh';
import { setPageMeta } from '../lib/seo';

export const UPDATES_TITLE = "What's New · SuperFunUBG";
export const UPDATES_DESCRIPTION = 'Every update to SuperFunUBG: new games, rebuilt games, new features and fixes, newest first.';

/** /updates: the public changelog (games/updates.ts). */
export function UpdatesPage() {
  useEffect(() => {
    setPageMeta(UPDATES_TITLE, UPDATES_DESCRIPTION, '/updates');
  }, []);
  return (
    <main id="main" className="legal">
      <div className="band band--hero legal__hero">
        <div>
          <h1 className="hero__title">What's New</h1>
          <p className="legal__date">New games, rebuilt games and fixes, newest first</p>
        </div>
      </div>
      <article className="legal__body updates">
        {UPDATES.map((u) => (
          <section key={u.date + u.title}>
            <p className="updates__date">{formatDay(u.date)}</p>
            <h2>{u.title}</h2>
            <ul>
              {u.items.map((i) => (
                <li key={i}>{i}</li>
              ))}
            </ul>
            {u.games && <GameLinks ids={u.games} />}
          </section>
        ))}
      </article>
      <nav className="legal__nav" aria-label="More">
        <Link to="/guides">Guides</Link>
        <Link to="/">All games</Link>
      </nav>
    </main>
  );
}
